export default function useResponseParser() {
    const parseSuccessResponseData = (response: any) => {
        return response.data.Data;
    };

    const parseErrorResponseData = (response: any) => {
        // Defensive: check if response.data exists
        const data = response?.response?.data;

        if (!data) {
            return "Unknown error occurred";
        }

        if (!data.Success && data.Error) {
            return data.Error; // Return the error message string
        }

        // Otherwise, return some fallback or the entire data
        return data;
    };
    return { parseSuccessResponseData, parseErrorResponseData };
}
